export const formCopy = {
  labels: {
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    name: 'Name',
    password: 'Password',
    projectName: 'Project Name',
    search: 'Search',
    status: 'Status',
    workspaceName: 'Workspace Name',
  },
  placeholders: {
    email: 'Enter your email',
    firstName: 'First Name',
    headerName: 'Enter header name',
    lastName: 'Last Name',
    password: 'Enter your password',
    projectName: 'Project Name',
    search: 'Search',
    select: 'Select...',
    workspaceName: 'Workspace Name',
  },
} as const;

export type FormLabelKey = keyof typeof formCopy.labels;
export type FormPlaceholderKey = keyof typeof formCopy.placeholders;

export const getFormLabel = (key: FormLabelKey): string => formCopy.labels[key];

export const getFormPlaceholder = (key: FormPlaceholderKey): string => formCopy.placeholders[key];

export const getSearchAriaLabel = (target: string): string => `Search ${target}`;

export const getFormLabelSamples = (): string[] => Object.values(formCopy.labels);

export const getFormCopySamples = (): string[] => [
  ...getFormLabelSamples(),
  ...Object.values(formCopy.placeholders),
  getSearchAriaLabel('projects'),
];
